export default function (error) {
  console.error(error);

  if (global.trackJs) {
    global.trackJs.track(error);
  }
}
